const CHINA_PATTERN = /^(中华人民共和国|中国|中國|china)$/i;
const MALAYSIA_PATTERN = /^(malaysia|马来西亚|馬來西亞)$/i;

/** 门店列表国家分组标题：按当前 i18n locale 显示 */
export function formatMapCountryName(countryName, t) {
  const raw = String(countryName || "").trim();
  if (!raw) return "-";
  if (CHINA_PATTERN.test(raw)) return t("app.home.map_country_china");
  if (MALAYSIA_PATTERN.test(raw)) return t("app.home.map_country_malaysia");
  return raw;
}
